import WixSDK from 'shared/utils/wix-sdk';
import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { vodAdapterLite } from 'shared/utils/adapters/vod-lite';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-shared/src/common/constants/video-cards';
import buildDeeplinkUrl from '@wix/wix-vod-shared/src/common/utils/build-deeplink-url';

const ACTIONS = createAsyncActions('SERVER.VIDEO-CARDS.GET');
const { START, SUCCESS, FAIL } = ACTIONS;

const deeplinkCardTypes = [VIDEO_CARD_TYPES.CHANNEL, VIDEO_CARD_TYPES.VIDEO, VIDEO_CARD_TYPES.RECENT_VIDEO];

const hasDeeplink = card => _.includes(deeplinkCardTypes, card.type);

const appendDeeplinks = (cardsData, fallbackUrl) => (
  _.map(cardsData, card => (
    hasDeeplink(card) ?
      {
        ...card,
        url: buildDeeplinkUrl({
          listId: card.actionListId,
          itemId: card.actionItemId,
          fallbackUrl,
        }),
      } :
      card
    )
  )
);

export const NAMES = ACTIONS.NAMES;

export default function (listId, itemId) {
  return function (dispatch) {
    const params = { id: itemId };

    dispatch(START(params));

    return Promise.all([
        vodAdapterLite.listItems.getActions(listId, itemId),
        WixSDK.getSiteUrl(),
      ])
      .then(([response, siteUrl]) => appendDeeplinks(response.data, siteUrl))
      .then(data => {
        dispatch(SUCCESS(params, data));
        return data;
      })
      .catch(errorResponse => {
        dispatch(
          FAIL(
            params,
            errorResponse,
            {
              analytics: {
                type: 'error',
                name: 'shared.video-cards.get',
              },
            }
          )
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/server/actions/video-cards/get.js